export default "__VITE_ASSET__vncikmyM__"